function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508 508",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FD8469"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M382.4,431.2H125.6c-8.4,0-15.2-6.8-15.2-15.2V92.4c0-8.4,6.8-15.2,15.2-15.2h256.8 c8.4,0,15.2,6.8,15.2,15.2V416C397.6,424.4,390.8,431.2,382.4,431.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M131.6,386.4V121.6c12.8,0,23.2-10.4,23.2-23.2h197.6c0,12.8,10.4,23.2,23.2,23.2V386 c-12.8,0-23.2,10.4-23.2,23.2H155.2C155.2,396.8,144.8,386.4,131.6,386.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M217.6,124c-11.2-1.6-25.2,8.8-26.4,18.8l0,0C201.2,140,210.8,132.8,217.6,124L217.6,124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M186,128L186,128c-10.8,10.4-10.8,23.6-4,27.2l0,0C187.6,145.2,191.2,134,186,128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M205.6,148.8c-5.2-6-17.2-4-23.6,6.4l0,0C189.2,159.2,198.4,155.2,205.6,148.8L205.6,148.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M172,144.4L172,144.4c-8,12-4.8,25.2,2.8,27.2l0,0C178,160.4,178.4,148.8,172,144.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M196,160c-6.4-4.8-17.2-0.4-21.2,11.2l0,0C182.4,173.6,190.8,168,196,160L196,160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M162.8,162.8L162.8,162.8c-4.8,13.2,0.8,25.2,8.4,25.6l0,0C172.4,177.2,170,166,162.8,162.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M189.2,172.8c-7.2-3.2-16.8,3.2-18,15.2l0,0C179.2,188.8,186,181.6,189.2,172.8L189.2,172.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M157.6,182.4L157.6,182.4c-2,14,6,24.4,14,23.2l0,0C170,194.4,165.2,184,157.6,182.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M186,186.8c-7.6-1.6-15.6,6.8-14.4,18.8l0,0C179.2,204.4,184.4,195.6,186,186.8L186,186.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M156.8,202.8L156.8,202.8c0.8,14,11.2,22.4,18.4,19.6l0,0C171.6,212,164.8,202.8,156.8,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M185.2,200.8c-8,0-14,10-10,21.6l0,0C182.4,219.6,186,210,185.2,200.8L185.2,200.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M160.4,223.2L160.4,223.2c4,13.6,16,20,22.4,15.2l0,0C176.4,228.8,168,221.2,160.4,223.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M187.6,214.8c-7.6,2-11.6,12.8-5.2,23.6l0,0C189.2,234,190.4,224,187.6,214.8L187.6,214.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M168.4,242L168.4,242c6.8,12.4,20.4,16,25.6,10.4l0,0C185.2,244,175.6,238.4,168.4,242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M193.2,228c-7.2,3.6-8.4,15.2,0.4,24.4l0,0C199.2,246.4,197.6,236.4,193.2,228L193.2,228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M219.6,264.8c-8.4-2-16-5.6-23.2-10c5.2,6.8,11.6,12.8,19.6,18C217.2,270,218.4,267.6,219.6,264.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M290.4,124c11.2-1.6,25.2,8.8,26.4,18.8l0,0C306.8,140,297.2,132.8,290.4,124L290.4,124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M322,128L322,128c10.8,10.4,10.8,23.6,4,27.2l0,0C320.4,145.2,316.8,134,322,128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M302.4,148.8c5.2-6,17.2-4,23.6,6.4l0,0C318.8,159.2,309.6,155.2,302.4,148.8L302.4,148.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M336,144.4L336,144.4c8,12,4.8,25.2-2.8,27.2l0,0C330,160.4,329.6,148.8,336,144.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M312,160c6.4-4.8,17.2-0.4,21.2,11.2l0,0C325.6,173.6,317.2,168,312,160L312,160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M345.2,162.8L345.2,162.8c4.8,13.2-0.8,25.2-8.4,25.6l0,0C335.6,177.2,338,166,345.2,162.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M318.8,172.8c7.2-3.2,16.8,3.2,18,15.2l0,0C328.8,188.8,322,181.6,318.8,172.8L318.8,172.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M350.4,182.4L350.4,182.4c2,14-6,24.4-14,23.2l0,0C338,194.4,342.8,184,350.4,182.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M322,186.8c7.6-1.6,15.6,6.8,14.4,18.8l0,0C328.8,204.4,323.6,195.6,322,186.8L322,186.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M351.2,202.8L351.2,202.8c-0.8,14-11.2,22.4-18.4,19.6l0,0C336.4,212,343.2,202.8,351.2,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M322.8,200.8c8,0,14,10,10,21.6l0,0C325.6,219.6,322,210,322.8,200.8L322.8,200.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M347.6,223.2L347.6,223.2c-4,13.6-16,20-22.4,15.2l0,0C331.6,228.8,340,221.2,347.6,223.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M320.4,214.8c7.6,2,11.6,12.8,5.2,23.6l0,0C318.8,234,317.6,224,320.4,214.8L320.4,214.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M339.6,242L339.6,242c-6.8,12.4-20.4,16-25.6,10.4l0,0C322.8,244,332.4,238.4,339.6,242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M314.8,228c7.2,3.6,8.4,15.2-0.4,24.4l0,0C308.8,246.4,310.4,236.4,314.8,228L314.8,228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M288.4,264.8c8.4-2,16-5.6,23.2-10c-5.2,6.8-11.6,12.8-19.6,18C290.8,270,289.6,267.6,288.4,264.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84DBFF"
    },
    d: "M294,224.8c-10,9.6-24,15.6-40,15.6s-30-6-40-15.6l0,0c1.6-5.2,5.6-9.6,10.4-12l15.6-7.6 c0.4-2,2.8-4.8,2.8-4.8c-1.2-1.6-2-3.6-2.8-5.6c-1.2,0-2.4-1.2-3.2-2.4c-0.8-1.6-0.8-3.2,0-4c-2.4-6.4-4-16.4,4-23.6l-4,0.8 c0,0,4.8-8.8,14.4-5.6c0,0-0.8-1.6-4-2.4c0,0,4.4-2,6.8,1.2c0,0,1.6-1.2,0-2.4c0,0,7.6,0.4,14,6.4c8.8,8.4,6.8,19.2,3.6,26.4 c0.4,0.8,0.4,2.4-0.4,3.6c-0.8,1.2-1.6,2.4-2.8,2.4c-0.8,0.8-2.4,4.4-3.2,5.6c0,0,2.4,2.8,2.8,4.8l15.6,7.6 C288.4,215.2,292.4,219.6,294,224.8L294,224.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 165.2,
    y: 306.8,
    style: {
      fill: "#CED5E0"
    },
    width: 177.6,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.2,
    y: 327.2,
    style: {
      fill: "#CED5E0"
    },
    width: 177.6,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.2,
    y: 347.6,
    style: {
      fill: "#CED5E0"
    },
    width: 177.6,
    height: 8.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.2,
    y: 368,
    style: {
      fill: "#CED5E0"
    },
    width: 102,
    height: 8.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.34d19ecd0d268700422529a8eac5b74b.svg";
export { ForwardRef as ReactComponent };